import "./App.css";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import useScrollReveal from "./useScrollReveal.js";
import AppContent from "./AppContent.js";

function App() {
  useScrollReveal();

  return (
    <>
    <Router>
      <AppContent />
    </Router>
{/* Botão fixo WhatsApp */}
        <a
  href="https://wa.me/5521983132240?text=Vim%20pelo%20site%20e%20gostaria%20de%20mais%20informações%20sobre%20os%20as%20consultas."
  target="_blank"
  rel="noopener noreferrer"
  className="whatsapp-button"
  onClick={() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "whatsapp_click",
      origem: "botao_flutuante",
      tipo: "whatsapp_fixo",
      pagina: window.location.pathname
    });
  }}
>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path d="M13.601 2.326A7.926 7.926 0 0 0 8.002 0C3.58 0 .002 3.58.002 8c0 1.41.37 2.78 1.07 3.98L0 16l4.13-1.07A7.94 7.94 0 0 0 8.002 16c4.42 0 8-3.58 8-8 0-2.13-.83-4.14-2.401-5.674zM8.002 14.5c-1.31 0-2.58-.34-3.7-.99l-.26-.15-2.46.64.66-2.39-.17-.25a6.49 6.49 0 0 1-1.01-3.36c0-3.58 2.92-6.5 6.5-6.5 1.74 0 3.38.68 4.61 1.91a6.49 6.49 0 0 1 1.89 4.59c0 3.58-2.92 6.5-6.5 6.5z" />
            <path d="M11.002 9.5c-.2-.1-1.17-.58-1.35-.65-.18-.07-.31-.1-.44.1-.13.2-.5.65-.61.78-.11.13-.22.15-.42.05-.2-.1-.84-.31-1.6-.99-.59-.52-.99-1.16-1.11-1.36-.12-.2-.01-.31.09-.41.09-.09.2-.22.3-.33.1-.11.13-.2.2-.34.07-.13.03-.25-.02-.35-.05-.1-.44-1.06-.61-1.45-.16-.39-.33-.34-.44-.35h-.38c-.13 0-.34.05-.52.25-.18.2-.68.66-.68 1.61 0 .95.7 1.87.8 2 .1.13 1.38 2.12 3.35 2.97.47.2.84.32 1.13.41.47.15.9.13 1.24.08.38-.06 1.17-.48 1.34-.95.17-.47.17-.87.12-.95-.05-.08-.18-.13-.38-.23z" />
          </svg>
        </a>
    </>
  );
}

export default App;